import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Backdrop } from '@mui/material';
import { CircularProgress, Typography } from '@emburse/embark-core';
import { useContext } from 'react';
import { loadingOverlayContext } from '../../providers/LoadingOverlayProvider';
export default function SimpleBackdrop() {
    const { openState, backdropMessageState } = useContext(loadingOverlayContext);
    const [open] = openState;
    const [backdropMessage] = backdropMessageState;
    return (_jsxs(Backdrop, { sx: {
            backgroundColor: 'rgba(255,255,255, 0.6);',
            zIndex: (theme) => theme.zIndex.drawer + 1
        }, open: open, children: [_jsx(CircularProgress, { color: "primary" }), backdropMessage && _jsx(Typography, { children: backdropMessage })] }));
}
